import React, {FC} from 'react';

export function Unauthorized() {
    return <div>You must be logged in to see that page.</div>
}